import React, { Component } from 'react';
import PropTypes from 'prop-types';
import observeRootStore from '../../../components/hoc/observeRootStore';

class CountryGroup extends Component {
    selectCountry = e => {
        const { rootStore } = this.props;
        rootStore.uiStore.activeMap = e.currentTarget.id;
    };

    render() {
        const { cid, transform } = this.props;
        return (
            <g
                id={cid}
                onClick={this.selectCountry}
                transform={transform}
            >
                {this.props.children}
            </g>
        );
    }
}

CountryGroup.propTypes = {
    rootStore: PropTypes.shape({
        uiStore: PropTypes.shape({
            activeMap: PropTypes.string,
        }).isRequired,
    }).isRequired,
    cid: PropTypes.string.isRequired,
    transform: PropTypes.string,
    children: PropTypes.node,
};

export default observeRootStore(CountryGroup);
